import axiosapi from "./axiosAPI";

// Get All MessageSubmissions
export const getAllMessageSubmissions = async (
    setMessageSubmissions,
    setFetcherror,
) => {
    
    
	try{
		const res =await axiosapi.get("/messagesubmissions");
        setMessageSubmissions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MessageSubmissions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MessageSubmissions");
		}
		
	}
	
};

// Get Specific MessageSubmissions
export const getSpecificMessageSubmissions = async (
    setMessageSubmissions,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    globalFilter,
    userId,
) => {
    
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10

    const options = {
        isprocessed: false,
        isdiscarded: false,
        page: page,
        limit: limit,
        search: globalFilter ? globalFilter : "",
        userid: userId
    }
     
    
	try{
		const res =await axiosapi.post("/specificmessagesubmissions",options);
        setMessageSubmissions(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MessageSubmissions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MessageSubmissions");
		}
		
	}
	
};


// Get One MessageSubmission
export const getOneMessageSubmission = async (
    pkid,
    setFetcherror,  
    setMessageSubmission
    
)=>{
	try{
		const res =await axiosapi.get(`/messagesubmissions/${pkid}`);
        setMessageSubmission(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch MessageSubmission");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch MessageSubmission");
		}
		
	}
	
};




// Create New MessageSubmission
export const createMessageSubmission = async (
    phone,
    content,
    type,
    setPhone,
    setContent,
    setType,
    setFetcherror,
    handleAllToasts

) => {


    if (!phone || !content || !type ) {
        handleAllToasts(2, "Either Phone, Content or Type is Missing"); 
            return; 
        }

    const PushItem = {
        phone,
        content,
        type
        };

    try{
        await axiosapi.patch("/messagesubmissions/",PushItem );
        setPhone("");
        setContent("");
        setType("");
        handleAllToasts(1, "MessageSubmission Created Successfully");
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New MessageSubmission");
            handleAllToasts(2, "Could Not update The MessageSubmission");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New MessageSubmission");
            handleAllToasts(2, "Could Not update The MessageSubmission");
            
        }
        
    }
    
}



// Change Post Status

export const changeMessageSubmissionStatus = async (
    messageSubmissionpkid,
    isprocessed,
    isdiscarded,
    setMessageSubmissions,
    setFetcherror,
    handleAllToasts,
    callback,
    userId
              
        ) => {

            if (!(isprocessed ||isdiscarded)) {
                handleAllToasts(2, "Discard or Process Statuses not triggered"); 
                    return;  
                }

            const PushItem = {

                id:messageSubmissionpkid,
                isprocessed:isprocessed,
                isdiscarded: isdiscarded,
            };
            if(userId){
                PushItem.user_id = userId;
            }

            try{
                await axiosapi.patch("/messagesubmissions/",PushItem );
                handleAllToasts(1, "Message Discarded Successfully");
                if (setMessageSubmissions) getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror);
                if (typeof callback === "function") callback(null, "Success");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 20
                    setFetcherror("Could Not Update MessageSubmission");
                    handleAllToasts(2, "Could Not Update MessageSubmission");
                    if (typeof callback === "function") callback(new Error("Could Not Update MessageSubmission"), null);
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update MessageSubmission");
                    handleAllToasts(2, "Could Not Update MessageSubmission");
                    
                }
                
            }
            
};


// Edit Existing MessageSubmission

export const editMessageSubmission = async (
    e,
    messageSubmissionpkid,
    isprocessed,
    isTrashed,
    setFetcherror,
    handleAllToasts,
    phone,
    content,
    type,
    setPhone,
    setContent,
    setType,
   
              
        ) => {
            e.preventDefault();

            if (!(phone ||content || type)) {
                handleAllToasts(2, "No Either Phone, Content or Type Provided"); 
                    return;  
                }

            const PushItem = {

                id:messageSubmissionpkid,
                phone,
                content,
                type   
                };

            try{
                await axiosapi.patch("/messagesubmissions/",PushItem );
                setPhone("");
                setContent("");
                setType("");
                handleAllToasts(1, "MessageSubmission Updated Successfully");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update MessageSubmission");
                    handleAllToasts(2, "Could Not Update MessageSubmission");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update MessageSubmission");
                    handleAllToasts(2, "Could Not Update MessageSubmission");
                    
                }
                
            }
            
};



// Delete Existing MessageSubmission.

export const deleteMessageSubmission = async (
    messageSubmissionpkid,
    setMessageSubmissions,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/messagesubmissions/${messageSubmissionpkid}`);
        let finalData = res.data.message;
        getAllMessageSubmissions(setMessageSubmissions, setFetcherror);
        handleAllToasts(1, "MessageSubmission Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete MessageSubmission");
            handleAllToasts(2,"Error: Could Not Delete MessageSubmission");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete MessageSubmission");
            handleAllToasts(2,"Error: Could Not Delete MessageSubmission");
		}
		
	}
	
};